export default __webpack_public_path__ + "t_logo.png";